import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { useCallback } from 'react';

export default function useUpdateUserLocationGq() {
  const [mutation, mutationResult] = useMutation<ResponseGq, VariablesGq>(gqTag);

  return useCallback(
    (command: UpdateUserLocationCommandGq) =>
      mutation({ variables: { command } }).then(
        (result) => result.data?.users?.editUserLocation?.ok ?? null
      ),
    []
  );
}

const gqTag = gql`
  mutation UpdateUserLocation($command: UpdateUserLocationCommand!) {
    users {
      updateUserLocation(command: $command) {
        ok
      }
    }
  }
`;

interface VariablesGq {
  command: UpdateUserLocationCommandGq;
}

interface ResponseGq {
  users: {
    editUserLocation: {
      ok: boolean;
    };
  };
}

export interface UpdateUserLocationCommandGq {
  locationId?: number;
}
